<template>
    <flex-element :element-type="elementType" class="f-break-words" :tag="tag">
        {{ formattedValue }}
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';
import FlexElement from '@/flex-element/flex-element-dumb';
import { formatDate } from '@/utils/date';

const CUSTOM_ATTR_NAME = 'date-format';

export default {
    name: 'a-text-single-line',
    components: { FlexElement },
    mixins: [baseAtom],

    props: {
        singleLineText: {
            type: String,
            default: '',
        },

        tag: {
            type: String,
            default: '',
        },
    },

    computed: {
        formattedValue() {
            const dateFormat = this.getElementData(CUSTOM_ATTR_NAME);
            if (dateFormat && this.singleLineText) {
                return formatDate(this.singleLineText, dateFormat);
            }
            return this.singleLineText;
        },
    },
};
</script>
